var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_155",
    "data-name": "Group 155",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M12,3a11,11,0,0,1,10.819,9A11,11,0,0,1,1.181,12,11,11,0,0,1,12,3Zm0,16a9,9,0,0,0,8.777-7A9,9,0,0,0,3.223,12,9.005,9.005,0,0,0,12,19Zm0-2.5A4.5,4.5,0,1,1,16.5,12,4.5,4.5,0,0,1,12,16.5Zm0-2A2.5,2.5,0,1,0,9.5,12,2.5,2.5,0,0,0,12,14.5Z",
    fill: "#d8d8d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen);
export default __webpack_public_path__ + "static/media/eyeopen.bb1de50aba43767565092c995cf2c320.svg";
export { ForwardRef as ReactComponent };